import { _IndirectCostType, _LabourType, _ProductionOrder, _ProductiveProcessType, _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicPage } from "../../theme/Component/BasicPage";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { FileInput } from "../../theme/Component/FileInput";
import { BasicButton } from "../../theme/Component/BasicButton";
import { PrintJson } from "../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { ErrorList } from "../../theme/Component/ErrorList";

export const ImportProductionOrder = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductionOrder);


    const importDoc = () => {
        instance.importProductionOrders(bean.Media, bean.MediaContext, null).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(err => {
            console.log(err)
            toast.error("No se pudo realizar la acción")
        })
    }

    return (
        <BasicPage titulo="Importar Ordenes de Producción" >
            <div className="row">
                <div className="col-md-8">
                    <FileInput onCreate={(e) => { setBean(e) }} />
                </div>

                <div className="col-md-4 mt-4">
                    <BasicButton eventClick={() => { importDoc() }} icon="ri-save-line" children={"Importar Documento"} />
                </div>

                <div className="col-md-12 mt-5">
                    {lista.length > 0 &&
                        <ErrorList lista={lista} />
                    }
                </div>
            </div>
        </BasicPage>
    )
}



